import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@/App.css';
const MainRoutes = lazy(() => import('./MainRoutes'));
const NewsApp = lazy(() => import('./news/NewsApp'));

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-neutral-950 text-white p-10" data-testid="site-loading">Loading…</div>}>
          {window.location.hostname === process.env.REACT_APP_NEWS_HOSTNAME ? <Routes><Route path="/*" element={<NewsApp />} /></Routes> : <Routes><Route path="/news/*" element={<NewsApp />} /><Route path="/*" element={<MainRoutes />} /></Routes>}
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
